export const getYoutubeId = (videoUrl: string): string | null => {
  const regexp =
    // eslint-disable-next-line no-useless-escape
    /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const matches = videoUrl.match(regexp);
  return matches ? matches[1] : null;
};
